<script>
  import { _ } from 'svelte-i18n'
  import { hobby_font_limit, user_installed_fonts_count, previews_nav_filters, detected_fonts } from '../../stores'
  import OpenBuyModalButton from '../../components/OpenBuyModalButton.svelte'
  import Insert from '../../elements/Insert.svelte'
  import Button from '../../elements/Button.svelte'

</script>

<div class="warning">
  {#if $previews_nav_filters.user}
    <p>
      You&rsquo;ve previewed <b>{$hobby_font_limit}</b> of your <b>{$user_installed_fonts_count}</b> fonts. Upgrade to see all.
    </p>
  {:else}
    <p>
      You&rsquo;ve previewed <b>{$detected_fonts.length - ($user_installed_fonts_count - $hobby_font_limit)}</b> of your <b>{$detected_fonts.length}</b> installed fonts. Upgrade to see all.
    </p>
  {/if}
</div>
<Insert insert_position='after_previews' permanent={true}>
  <span slot="toptitle">
    PRO FEATURE: UNLIMITED FONT PREVIEWS
  </span>
  <span slot="title">
    Free Plan Limit Reached<br>
  </span>
  <span slot="text">
    The free version of Wordmark can preview up to {$hobby_font_limit} of the {$user_installed_fonts_count} fonts you&rsquo;ve installed on your computer, plus your system fonts. Upgrade to see them all.
  </span>
  <span slot="button">
    <OpenBuyModalButton feature='unlimited_previews'>Upgrade to Wordmark Pro</OpenBuyModalButton>
    <Button kind='outline' href='/letter-from-the-founder' target='_blank'> ↗︎ About the free plan limit</Button>
  </span>
</Insert>

<style>
  .warning {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: center;
    font-variant: lining-nums;
  }
  .warning p {
    width: fit-content;
    padding: 1rem 2rem;
    margin: 1rem;
    background-color: var(--c-warning-bg);
    color: var(--c-warning-text);
    font-size: 1.6rem;
  }
</style>